import '../boot'
import './Application'
import '../../scss/agronomy'
import newLoginBg from '!!raw-loader!../../assets/images/agronomy/new-login/bg.svg'
import newLoginLogo from '../../assets/images/agronomy/new-login/agronomy-light.png'
import newLoginTpl from '../../templates/Agronomy/NewLogin.ejs'

const appRun = global.appRun = async function (page) {
    const $spinner = $('.sk-cube-spinner')

    switch (page) {
        case 'index':
            await runIndex()
            break
        case 'login':
            await runLogin()
            break
        case 'newLogin':
            await runNewLogin()
            break
    }

    await Promise.resolve($spinner.fadeOut().promise())
    $spinner.remove()

    return Promise.resolve($('#layout').fadeIn().promise())
}

export default appRun

function runIndex() {
    const application = global.application = new Agronomy.Application()

    return new Promise(resolve => {
        application.init(() => application.run(() => {
            $('#loaderPage').remove()
            resolve()
        }))
    })
}

function runLogin() {
    const application = global.application = new Agronomy.Application()

    $("#login, #password").on("keydown", (args) => {
        if (args.keyCode === KeyCode.Enter) {
            $('#submit').trigger('click')
        }
    })

    $("#submit").on("click", () => {
        const login = $('#login').val()
        const password = $('#password').val()
        const options = {}

        application.login(login, password, options)
            .then(() => {
                document.location.href = '/'
            })
            .catch(() => {
                alert('Неверные учётные данные')

                $('#password').val('')
                $('#login').focus()
            })
    })

    $('#login').focus()

    return new Promise(resolve => application.init(resolve))
}

function runNewLogin () {
    let layout = document.querySelector('#layout')
    layout.innerHTML = newLoginTpl({
        svg: newLoginBg,
        logo: newLoginLogo,
    })

    document.querySelector('#password-visible').addEventListener('click', togglePassword)
    let submit = document.querySelector('#submit')
    submit.addEventListener('click', submitLogin)
    document.querySelectorAll('#login, #password').forEach(elem => elem.addEventListener('keyup', ({ keyCode }) => {
        if (keyCode === KeyCode.Enter) {
            submit.click()
        }
    }))

    document.querySelector('#login').focus()

    const application = global.application = new Agronomy.Application()

    return new Promise(resolve => application.init(resolve))
}

// login helpers
function togglePassword () {
    const x = document.getElementById('password')
    const p = document.getElementById('password-visible').classList

    if (x.getAttribute('type') === 'password') {
        x.setAttribute('type', 'text')
        p.remove('visible_off')
        p.add('visible')
    } else {
        x.setAttribute('type', 'password')
        p.remove('visible')
        p.add('visible_off')
    }
}

async function submitLogin () {
    if (!validateLogin()) return

    let login = document.querySelector('#login')
    let password = document.querySelector('#password')

    try {
        await application.login(login.value, password.value, {})
        document.location.href = '/'
    } catch (err) {
        alert('Неверные учётные данные')
        password.value = ''
        login.focus()
        login.select()
    }
}

function validateLogin () {
    const login = document.getElementById('login')
    const loginLabel = document.getElementById('login-label').classList
    const password = document.getElementById('password')
    const passwordLabel = document.getElementById('password-label').classList
    const avaya = document.getElementById('avaya')
    const avayaLabel = document.getElementById('avaya-label')
    let valid = true

    if (login.value === '') {
        login.classList.remove('valid')
        login.classList.add('invalid', 'error')
        loginLabel.add('label')
        login.placeholder = 'Необходимо заполнить поле'
        valid = false
    } else {
        login.classList.remove('invalid')
        login.classList.add('valid')
        login.placeholder = ''
    }

    if (password.value === '') {
        password.classList.remove('valid')
        password.classList.add('invalid', 'error')
        passwordLabel.add('label')
        password.placeholder = 'Необходимо заполнить поле'
        valid = false
    } else {
        password.classList.remove('invalid')
        password.classList.add('valid')
        password.placeholder = ''
    }

    if (avaya != null) {
        if (avaya.value === '') {
            avaya.classList.remove('valid')
            avaya.classList.add('invalid', 'error')
            avayaLabel.classList.add('label')
            avaya.placeholder = 'Необходимо заполнить поле'
            valid = false
        } else {
            avaya.classList.remove('invalid')
            avaya.classList.add('valid')
            avaya.placeholder = ''
        }
    }

    return valid
}
